// src/components/layout/MobileMenu.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';
import { NAVIGATION_LINKS } from '../../utils/constants';
import { createAnchorClickHandler } from '../../utils/scrollUtils';

const MobileMenu = ({ isOpen, onClose, aboutDropdownItems = [] }) => {
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const location = useLocation();
  
  const toggleAboutDropdown = () => {
    setIsAboutOpen(!isAboutOpen);
  };

  return (
    <div
      className={`fixed top-0 left-0 w-full h-screen bg-primary-dark z-40 transform transition-transform duration-300 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } overflow-y-auto`}
    >
      <div className="container py-20">
        <nav className="flex flex-col space-y-6">
          {NAVIGATION_LINKS.map((link) => {
            // Check if this link matches the current path
            const isActive = location.pathname === link.path || 
                           (link.path !== '/' && location.pathname.startsWith(link.path));
                           
            // Special handling for About link
            if (link.name === 'About') {
              return (
                <div key={link.path} className="space-y-2">
                  <div className="flex items-center justify-between">
                    <Link
                      to={link.path}
                      className={`text-xl font-medium hover:text-secondary transition-colors ${
                        isActive ? 'text-secondary font-semibold' : 'text-white'
                      }`}
                      onClick={onClose}
                    >
                      {link.name}
                    </Link>
                    <button 
                      onClick={toggleAboutDropdown}
                      className="text-white p-2 hover:text-secondary"
                      aria-label="Toggle about dropdown"
                    >
                      <FaChevronDown className={`transition-transform ${isAboutOpen ? 'rotate-180' : ''}`} />
                    </button>
                  </div>
                  
                  {/* About dropdown items */}
                  {isAboutOpen && (
                    <div className="pl-4 space-y-3 border-l border-gray-700 ml-2">
                      {aboutDropdownItems.map((item, index) => {
                        // Check if this section is active
                        const isSectionActive = isActive && location.hash === `#${item.id}`;
                        
                        // If already on about page, use smooth scrolling
                        if (location.pathname === '/about') {
                          return (
                            <a
                              key={index}
                              href={`#${item.id}`}
                              className={`block hover:text-secondary transition-colors ${
                                isSectionActive ? 'text-secondary font-medium' : 'text-gray-300'
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                onClose();
                                
                                const elementId = item.id;
                                const element = document.getElementById(elementId);
                                
                                if (element) {
                                  const headerOffset = 100; // Adjust based on your header height
                                  const elementPosition = element.getBoundingClientRect().top;
                                  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                                  
                                  window.scrollTo({
                                    top: offsetPosition,
                                    behavior: 'smooth'
                                  });
                                  
                                  // Update URL without triggering a page reload
                                  window.history.pushState(null, '', `#${elementId}`);
                                }
                              }}
                            >
                              {item.name}
                            </a>
                          );
                        }
                        
                        // Regular link for other pages
                        return (
                          <Link
                            key={index}
                            to={item.path}
                            className={`block hover:text-secondary transition-colors ${
                              isSectionActive ? 'text-secondary font-medium' : 'text-gray-300'
                            }`}
                            onClick={onClose}
                          >
                            {item.name}
                          </Link>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            }
            
            // Regular link
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`text-xl font-medium hover:text-secondary transition-colors ${
                  isActive ? 'text-secondary font-semibold' : 'text-white'
                }`}
                onClick={onClose}
              >
                {link.name}
              </Link>
            );
          })}
          <Link
            to="/apply"
            className="inline-flex items-center bg-secondary text-white px-4 py-2 rounded-md font-medium hover:bg-secondary-dark transition-colors mt-4 w-max"
            onClick={onClose}
          >
            Apply Now
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 ml-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              />
            </svg>
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;